@layer design-system {
  .rectBackground {
    fill: var(--surface-hover);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .verticalBarRoot:hover {
    .rectBackground {
      opacity: 0.6;
      transition: none;
    }
  }
}
